import {IEvent} from 'modules/wineshops-list/models';
import {FC, ReactNode} from 'react';
import Link from 'components/Link';

import style from './style.module.scss';
import {EventCard} from 'modules/events/components/EventCard';

interface IProps {
    events: IEvent[];
    titleNode?: ReactNode;
}

export const EventsBlock: FC<IProps> = ({events, titleNode}) => {
    return (
        <>
            {titleNode ?? (
                <div className={style.titleContainer}>
                    <h2 className={style.title}>Дегустации</h2>
                    <Link
                        className={style.link}
                        href={'/events'}
                        isUnderlining={true}
                        text={'Все дегустации'}
                        theme={'black'}
                    />
                </div>
            )}
            <div className={style.eventsWrapper}>
                {events?.map((event) => (
                    <EventCard key={event.id} {...event} />
                ))}
            </div>
        </>
    );
};
